import './experience-cards.css';
import cardImg1 from '../../assets/img/about/asset 3.jpeg'
import cardImg2 from '../../assets/img/about/asset 4.jpeg'
import cardImg3 from '../../assets/img/about/asset 5.jpeg'
import mainCardImg from '../../assets/img/about/asset 6.jpeg'

const ExperienceCards = () => {
	return (
		<section className="experience-card">
			<div className="container">
				<div className="text-zone">
					<span>Langjährige Erfahrung</span>
					<h2>Seit 2005 sind wir für Sie im Einsatz</h2>
					<p>Gründerin der mobile Pflege Petker ist Elisabeth Petker. Ihr hohes Engagement und Ihre Überzeugung haben dazu beigetragen, dass den Menschen, die wir pflegen und betreuen, trotz Ihres Hilfebedarfs eine möglichst eigenständige und selbstbestimmte Lebensführung in Ihrer häuslichen Umgebung ermöglicht wird.</p>
					<div className="small-cards">
						<img src={ cardImg1 } alt="card-img-1" />
						<img src={ cardImg2 } alt="card-img-2" />
						<img src={ cardImg3 } alt="card-img-3" />
					</div>
				</div>
				<div className="card-holder">
					<img src={mainCardImg} alt="main-card-img" />
				</div>
			</div>
		</section>
	)
}

export default ExperienceCards
